<!--
  VideoCard · 视频卡片（<video> + 底部状态条 + 控制按钮）
  props: chipSent / chipStep / chipStepOn / chipLock / chipLockOn
  emit:  clickPrev / clickReplay / clickNext
  暴露给父：
    - videoRef: 原生 <video> 引用
    - applySpeedActive(rate): 父改倍速后高亮对应按钮
    - applySubActive(mode): 父改字幕后高亮对应按钮（在 HeaderBar 做了，这里省略）
-->
<template>
  <section class="video-card">
    <div class="video-wrap">
      <video ref="videoRef" controls preload="metadata" crossorigin="anonymous" playsinline>
        您的浏览器不支持 HTML5 Video。
      </video>
    </div>
    <div class="status-bar">
      <div class="row">
        <span class="chip">{{ chipSent }}</span>
        <span class="chip" :class="{on: chipStepOn}">{{ chipStep }}</span>
        <span class="chip" :class="{on: chipLockOn}">{{ chipLock }}</span>
      </div>
      <div class="row">
        <button @click="$emit('clickPrev')">← 上一句</button>
        <button style="background:#2a3b7e55" @click="$emit('clickReplay')">↺ 重放(R)</button>
        <button @click="$emit('clickNext')">下一句 →</button>
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref } from 'vue'

defineProps({
  chipSent: { type: String, default: '句 0 / 0' },
  chipStep: { type: String, default: '阶梯 OFF' },
  chipStepOn: { type: Boolean, default: false },
  chipLock: { type: String, default: '🔓 未锁定' },
  chipLockOn: { type: Boolean, default: false },
})
defineEmits(['clickPrev', 'clickReplay', 'clickNext'])

const videoRef = ref(null)
defineExpose({
  videoRef,
  applySpeedActive(rate) {
    const btns = document.querySelectorAll('#speedBar button')
    btns.forEach(b => {
      const r = +b.getAttribute('data-rate')
      b.classList.toggle('active', Math.abs(r - rate) < 0.001)
    })
  },
})
</script>
